import type { ReactNode } from "react";

interface DeviceFrameProps {
  children: ReactNode;
}

/**
 * Phone-shaped wrapper for previewing a Sked Link inside the editor.
 * Replaces the legacy iPhone X marvel-device frame (whose bundled CSS file
 * was empty in the source repo, so the legacy frame was decorative-only).
 */
export function DeviceFrame({ children }: DeviceFrameProps) {
  return (
    <div className="sked-device-frame">
      <div className="sked-device-screen">{children}</div>
    </div>
  );
}
